// extracted by mini-css-extract-plugin
export default {"container":"RiskFactorAutoComplete_container__tq1N-","listContainer":"RiskFactorAutoComplete_listContainer__W7z7i","riskfactorList":"RiskFactorAutoComplete_riskfactorList__-hs04"};